<template>
    <div class='student-profile' v-if="student">
        <div class='section'>
            <div class='container'>
                <div class='columns is-multiline'>
                    <div class='column is-3-widescreen is-offset-1-widescreen is-4-desktop is-12-touch'>
                        <div class="box is-shadowless is-radiusless">
                            <div class="columns is-multiline">
                                <div class="column is-12-mobile is-12-desktop is-narrow">
                                    <avatar class="avatar" :account="student" :size="200" round />
                                </div>

                                <div class="column is-12-mobile is-12-desktop">
                                    <h1 class='title name is-size-3 is-bold is-spaced'>{{student.name}}
                                        <span v-if="student.is_new" class="has-text-primary is-size-6">{{$t('students.profile.new')}}</span>
                                    </h1>

                                    <p class="level-wrapper">
                                        <span class="has-text-weight-bold">{{$t('students.profile.level')}}</span>:

                                        <small>
                                            {{$t(`levels.${student.level.name}.name`)}} <level-icon :level="student.level" size="is-small" />
                                        </small>
                                    </p>

                                    <short class="short" :student="student" />

                                    <div class="has-text-centered-desktop">
                                        <button v-if="isCustomer || !isLoggedIn" @click="toggleContactModal"
                                                type="button" class="button is-primary is-medium contact-button">
                                            <b-icon icon="message-text" />
                                            <span>{{$t('students.profile.contact')}}</span>
                                        </button>
                                    </div>

                                    <contact-modal v-if="showContactModal" @hide="toggleContactModal" :student="student" />

                                    <div class="stat has-text-centered-desktop">
                                        <template v-if="student.average_rating">
                                            <p class='stat__title'>{{$t('students.profile.ratingsScore')}}</p>

                                            <div class='stat__stars'>
                                                <stars :average="student.average_rating" />
                                            </div>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class='column is-7-widescreen is-8-desktop is-12-touch'>
                        <div class="box is-radiusless is-shadowless">
                            <b-tabs size="is-medium" class="block">
                                <b-tab-item :label="$t('students.profile.about')" icon="account-details">
                                    <about :student="student" />
                                </b-tab-item>

                                <b-tab-item :label="$t('students.profile.skillTable')" icon="clipboard-text">
                                    <skill-table :student="student" />
                                </b-tab-item>

                                <b-tab-item :label="$t('students.profile.ratings')" icon="star" v-if="student.ratings.length" >
                                    <ratings-list :student="student" />
                                </b-tab-item>
                            </b-tabs>
                        </div>

                        <references :references="student.references" :student="student" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<style lang="scss" scoped>
    @import '../../../global/styles/_variables';

    .student-profile {
        background: $background-blueish;

        .avatar {
            margin: 0 auto 15px;
        }

        .name {
            margin-bottom: 10px;
        }

        .level-wrapper {
            margin-bottom: 15px;
        }

        .short {
            margin-bottom: 25px;
        }

        .contact-button {
            margin: 0 auto 15px;
        }

        .stat {
            .stat__title {
                font-size: 1.2rem;
                font-weight: 200
            }

            .stat__stars {
                padding-top: 5px;
            }
        }
    }
</style>

<script>
    import { mapGetters } from 'vuex';
    import ContactModal from '@/taskflex/students/components/contact/ContactModal';
    import StudentService from '@/taskflex/students/services/StudentService';
    import LevelIcon from '@/taskflex/levels/components/LevelIcon';
    import About from '@/taskflex/students/components/profile/About';
    import SkillTable from '@/taskflex/students/components/profile/SkillTable';
    import Short from '@/taskflex/students/components/profile/Short';
    import References from '@/taskflex/students/components/profile/references/References';
    import Avatar from '@/taskflex/users/components/Avatar';
    import Stars from '@/taskflex/students/components/profile/ratings/Stars';
    import RatingsList from '@/taskflex/students/components/profile/ratings/RatingsList';

    export default {
        data() {
            return {
                student: null,
                average: 0.0,
                showContactModal: false,
            };
        },

        computed: {
            ...mapGetters('auth', [
                'isCustomer',
                'isLoggedIn',
            ]),
        },

        mounted() {
            this.load();

            this.$eventHub.$on('students.profile.update', this.load);
        },

        beforeDestroy() {
            this.$eventHub.$off('students.profile.update', this.load);
        },

        methods: {
            load() {
                const { slug } = this.$route.params;

                const options = {
                    includes: [
                        'skills.paygrades',
                        'skills.skillGroup',
                        'level',
                        'ratings',
                        'references',
                    ],
                };

                StudentService.findBySlug(slug, options, (response) => {
                    this.student = response.data;
                }, ({ response }) => {
                    if (response.status === 404) {
                        this.$router.replace({ name: 'students.search' });
                    }
                });
            },

            toggleContactModal() {
                this.showContactModal = !this.showContactModal;
            },

        },

        components: {
            ContactModal,
            LevelIcon,
            About,
            SkillTable,
            References,
            Avatar,
            Short,
            Stars,
            RatingsList,
        },
    };
</script>



// WEBPACK FOOTER //
// src/taskflex/students/pages/Profile.vue